import { render, staticRenderFns } from "./LicensePlateStats.vue?vue&type=template&id=a7a5b12c&scoped=true"
import script from "./LicensePlateStats.vue?vue&type=script&lang=js"
export * from "./LicensePlateStats.vue?vue&type=script&lang=js"
import style0 from "./LicensePlateStats.vue?vue&type=style&index=0&id=a7a5b12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a5b12c",
  null
  
)

export default component.exports